var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExclamationIcon = function SvgExclamationIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.95385 8.95385 0 20 0C31.0462 0 40 8.95385 40 20C40 31.0462 31.0462 40 20 40C8.95385 40 0 31.0462 0 20ZM4.61538 20C4.61538 28.4831 11.5169 35.3846 20 35.3846C28.4831 35.3846 35.3846 28.4831 35.3846 20C35.3846 11.5169 28.4831 4.61538 20 4.61538C11.5169 4.61538 4.61538 11.5169 4.61538 20ZM21.7226 23.9231L22.7995 8.94H17.1995L18.2764 23.9231H21.7226ZM21.6614 25.3375L17.1394 26.5373L18.3393 31.0593L22.8612 29.8595L21.6614 25.3375Z",
    fill: "#0A9828"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "exclamation-icon.1c07de9c7d67b501a2180e16ebb1aaf0.svg";